import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/HomeView.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/AboutView.vue')
  },
  {
    path: '/report',
    name: 'Report',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/ReportView.vue')
  },
  {
    path: '/report2',
    name: 'Report2',
    meta: { layout: "ReportLayout" },
    component: () => import('../views/Website/Report2View.vue')
  },
  {
    path: '/media-center',
    name: 'MediaCenter',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/MediaCenterView.vue')
  },
  {
    path: '/media-center/news',
    name: 'AllNews',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/NewsView.vue')
  },
  
  {
    path: '/media-center/news/details',
    name: 'DetailsNews',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/DetailsNewsView.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/ContactView.vue')
  },
  {
    path: '/why-alula',
    name: 'WhyAlulaView',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/WhyAlulaView.vue')
  },
  {
    path: '/speakers',
    name: 'Speakers',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/SpeakersView.vue')
  },
  {
    path: '/agenda',
    name: 'Agenda',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/AgendaView.vue')
  },
  {
    path: '/agenda/Agenda-details',
    name: 'AgendaDetails',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/AgendaDetailsView.vue')
  },
  {
    path: '/travel',
    name: 'Travel',
    meta: { layout: "WebLayout" },
    component: () => import('../views/Website/TravelView.vue')
  },
  {
    path: '/registration/step1',
    name: 'RegistrationStep1',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/RegistrationStep1View.vue')
  },
  {
    path: '/registration/media/step1',
    name: 'MediaRegistrationStep1',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/MediaRegistrationStep1View.vue')
  },
  {
    path: '/registration/media/step2',
    name: 'MediaRegistrationStep2',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/MediaRegistrationStep2View.vue')
  },
  {
    path: '/registration/thankyou',
    name: 'ThankYou',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/ThankyouView.vue')
  },
  {
    path: '/registration/step2',
    name: 'RegistrationStep2',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/RegistrationStep2View.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { layout: "ProfileLayout" },
    component: () => import('../views/Registration/ProfileView.vue')
  },
  {
    path: '/flight',
    name: 'Flight',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/FlightView.vue')
  },
  {
    path: '/hotel',
    name: 'Hotel',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/HotelView.vue')
  },
  {
    path: '/visa',
    name: 'Visa',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/VisaView.vue')
  },
  {
    path: '/media-visa',
    name: 'MediaVisa',
    meta: { layout: "RegLayout" },
    component: () => import('../views/Registration/MediaVisaView.vue')
  },
  {
    path: '/gala-dinner',
    name: 'GalaDinner',
    meta: { layout: "NoHeaderLayout" },
    component: () => import('../views/Registration/GalaDinnerView.vue')
  },
  {
    path: '/room-booking',
    name: 'RoomBooking',
    meta: { layout: "NoHeaderLayout" },
    component: () => import('../views/Registration/RoomBookingView.vue')
  },
  {
    path: '/side-tour',
    name: 'SideTour',
    meta: { layout: "NoHeaderLayout" },
    component: () => import('../views/Registration/SideTourView.vue')
  },
  {
    path: '/reception/checkin',
    name: 'Checkin',
    meta: { layout: "NoHeaderLayout" },
    component: () => import('../views/Reception/CheckinView.vue')
  },
  {
    path: '/reception/login',
    name: 'Login',
    meta: { layout: "NoHeaderLayout" },
    component: () => import('../views/Reception/LoginView.vue')
  },
  {
    path: '/badge',
    name: 'Badge',
    meta: { layout: "NoHeaderLayout" },
    component: () => import('../views/Registration/BadgeView.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
